/* Stella custom JS — reveal on scroll, hero slideshow, parallax leggero */
(function () {
  'use strict';

  // Reveal on scroll
  function setupReveal() {
    const els = document.querySelectorAll('.stl-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(e => e.classList.add('is-in'));
      return;
    }
    // Elementi gia' nel primo viewport: applica is-in subito (no flash)
    const winH = window.innerHeight || 800;
    els.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < winH * 0.95) el.classList.add('is-in');
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
    els.forEach(el => { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  // Hero slideshow with crossfade + ken burns
  function setupHero() {
    document.querySelectorAll('.stl-hero').forEach(hero => {
      const slides = hero.querySelectorAll('.stl-hero__slide');
      const dots = hero.querySelectorAll('.stl-hero__dot');
      if (slides.length < 2) {
        if (slides[0]) slides[0].classList.add('is-active');
        return;
      }
      let idx = 0;
      slides[0].classList.add('is-active');
      if (dots[0]) dots[0].classList.add('is-active');
      const ms = parseInt(hero.dataset.interval || '7000', 10);

      function go(n) {
        slides[idx].classList.remove('is-active');
        if (dots[idx]) dots[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
      const t = setInterval(() => go(idx + 1), ms);

      dots.forEach((d, i) => {
        d.addEventListener('click', () => {
          go(i);
        });
      });
    });
  }

  // Parallax leggero su immagine storia
  function setupParallax() {
    const targets = document.querySelectorAll('[data-stl-parallax]');
    if (!targets.length) return;
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const winH = window.innerHeight;
        targets.forEach(t => {
          const r = t.getBoundingClientRect();
          if (r.bottom < 0 || r.top > winH) return;
          const progress = (winH - r.top) / (winH + r.height);
          const offset = (progress - 0.5) * 60; // px
          t.style.transform = 'translateY(' + (-5 + offset * 0.3) + '%)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Prenota pro: slot picker + WA submit
  function setupPrenotaPro() {
    document.querySelectorAll('[data-stl-prenota]').forEach(form => {
      const slotBtns = form.querySelectorAll('.stl-prenota__slot');
      const slotInput = form.querySelector('input[name="slot"]');
      slotBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          slotBtns.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (slotInput) slotInput.value = btn.dataset.slot;
        });
      });

      // min/max date
      const dateInput = form.querySelector('input[name="date"]');
      if (dateInput) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        dateInput.min = yyyy + '-' + mm + '-' + dd;
        // max 90 giorni avanti
        const max = new Date(today.getTime() + 90 * 86400000);
        dateInput.max = max.getFullYear() + '-' + String(max.getMonth() + 1).padStart(2, '0') + '-' + String(max.getDate()).padStart(2, '0');
      }

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        // Kill switch: se enabled=false non apre WhatsApp, mostra solo un avviso
        if (form.dataset.enabled === 'false') {
          const msg = form.dataset.disabledMsg || 'Prenotazioni online momentaneamente non attive. Per prenotare, chiama il ristorante al 081 7644086.';
          alert(msg);
          return;
        }
        const data = {
          name: form.querySelector('[name=name]').value.trim(),
          phone: form.querySelector('[name=phone]').value.trim(),
          people: form.querySelector('[name=people]').value,
          date: form.querySelector('[name=date]').value,
          slot: form.querySelector('[name=slot]').value,
          note: (form.querySelector('[name=note]') || { value: '' }).value.trim()
        };
        if (!data.name || !data.phone || !data.date || !data.slot) {
          alert('Compila i campi obbligatori e seleziona un orario.');
          return;
        }
        const dateIT = data.date.split('-').reverse().join('/');
        const wa = form.dataset.wa || '393382982582';
        const msg =
          'Buongiorno, vorrei prenotare al Ristorante Stella.\n\n' +
          'Nome: ' + data.name + '\n' +
          'Telefono: ' + data.phone + '\n' +
          'Persone: ' + data.people + '\n' +
          'Data: ' + dateIT + '\n' +
          'Turno: ' + data.slot + '\n' +
          (data.note ? 'Note: ' + data.note + '\n' : '') +
          '\nResto in attesa di conferma. Grazie.';
        window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank');
      });
    });
  }

  function init() {
    // Attivo le animazioni solo se IntersectionObserver e' disponibile e prefers-reduced-motion non e' set
    var prm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !prm) {
      document.body.classList.add('stl-anim');
    }
    setupReveal();
    setupHero();
    setupParallax();
    setupPrenotaPro();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
